import React from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'
import Icon from 'components/Icon'
import Typography from 'components/Typography'

import classes from './EmptyUserInfo.module.scss'

/** @type {import("./types").default} */
const EmptyUserInfo = ({ className, ...props }) => (
  <Grid className={clsx('EmptyUserInfo', classes.root, className)} {...props}>
    <div className={classes.userIconBgExp}>
      <Icon icon={'circle-user'} size={24} />
    </div>

    <div className={classes.text}>
      <Typography variant="heading-sm">User Name</Typography>
      <Typography variant="tight-xs">Occupation</Typography>
    </div>
  </Grid>
)

export default EmptyUserInfo
